module.exports = __webpack_public_path__ + "adb9d3d296fd3f3cdac22d832757a011.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/icons/laptop.png
// module id = 276
// module chunks = 0